/* Publish by EComposer at 2025-08-05 21:34:58*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6kiic72pyt"]=  window.__ectimmers["ecom-6kiic72pyt"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6kiic72pyt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kiic72pyt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pii9vwyv0v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pii9vwyv0v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sjk6t0czut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sjk6t0czut', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sabl60tgtlg"]=  window.__ectimmers["ecom-sabl60tgtlg"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-sabl60tgtlg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sabl60tgtlg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-plw70dcdhcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plw70dcdhcg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sy38t9cgpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sy38t9cgpe', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}